import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { s3baseUri } from "../../config/config";
import RecordNoImage from "../recordNotFound/RecordNoImage";
import CloseIcon from "@mui/icons-material/Close";
import CircularLoader from "../loader/CircularLoader";
import { enqueueSnackbar } from "notistack";
import { useIds } from "../../hook/AdminContext";
import ClientDetails from "../../pages/Clients/components/ClientDetails";
import { coach_details } from "../../DAL/Coach/coach";
import { get_client_details } from "../../DAL/clientTypes/ClientTpes";
import { useParams } from "react-router-dom";
import { show_proper_words } from "../../utils/Constant";
import { leader_details } from "../../DAL/Leaders/Leader";
import DetailsForCoachAndLeader from "../../pages/Clients/components/DetailsForCoachAndLeader";

export default function CompanyPopup({
  companyModalOpen,
  handleCloseCompanyModal,
  companyModalData,
  isCoachModal = false,
  companyType = "",
  isCompanyProfile = false,
  width = "1150px",
}) {
  const [companyData, setCompanyData] = useState();
  const [loading, setLoading] = useState(false);
  const { userInfo } = useIds();
  const { source_slug } = useParams();
  const fetchData = async () => {
    setLoading(true);
    const response =
      isCoachModal && companyType == "coach"
        ? await coach_details(companyModalData?._id)
        : isCoachModal && companyType == "leader"
          ? await leader_details(companyModalData?._id)
          : await get_client_details(companyModalData?._id, "");
    if (response.code === 200) {
      if (isCoachModal && (companyType == "coach" || companyType == "leader")) {
        setCompanyData(response.data);
      } else {
        setCompanyData({
          ...response.user,
          client_type:
            response?.user?.client_type.filter((type) => type?.sector?.title) ||
            [],
        });
      }
      setLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      console.error("Failed to fetch company data", response.message);
    }
  };
  useEffect(() => {
    if (companyModalData?._id && companyModalOpen) {
      fetchData();
    }
  }, [companyModalOpen]);

  return (
    <Dialog
      open={companyModalOpen}
      onClose={handleCloseCompanyModal}
      scroll="paper"
      className="custom-model-wrapper"
      PaperProps={{
        className: "custom-model-paper",
        style: {
          width: width,
          maxWidth: "100%",
        },
      }}
    >
      {/* Fixed header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e0e0e0",
          pb: 1,
        }}
        className="text-capitalize"
      >
        {isCoachModal
          ? `${show_proper_words(companyType)} Profile`
          : "Company Profile"}

        <div onClick={handleCloseCompanyModal} className="model-red-cross">
          <CloseIcon />
        </div>
      </DialogTitle>
      {/* Scrollable content below header, no horizontal scroll */}
      <DialogContent className="p-4 card-1 custom-modal-content">
        {loading ? (
          <CircularLoader />
        ) : (
          <Box className="container-fluid" sx={{ p: 2 }}>
            <Box className="row mt-3">
              <ClientDetails
                data={companyData}
                isCoachModal={isCoachModal}
                isCompanyProfile={isCompanyProfile}
                companyType={companyType}
                showSideBar={false}
                fetchDetails={fetchData}
              />
            </Box>
          </Box>
        )}
      </DialogContent>

    </Dialog>
  );
}
